import React from "react";
import MainImg3 from "../../../assets/illustrations2/PNG/why_choose_exactmails.png";
import Line from "../../../assets/line2.svg";
// import { FaCheck } from "react-icons/fa";
import check from "../../../assets/check.svg";
import UnderImg from "../../../assets/under.svg";

export default function Context() {
  return (
    <>
      <div className="bg-[#f4f8ff] py-8 px-5 flex flex-col items-center">
        <div className="text-center w-full md:w-[70%] mb-8 mt-2 lg:mt-12">
          <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
            Why choose Exact{" "}
            <span className="relative inline-block">
              Mails.io
              <img
                src={Line}
                alt="Underline decoration"
                className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
              />
            </span>
          </h2>
          <p className="text-xl md:text-[22px] my-4 mt-6">
            There's no email we can't find
          </p>
          <p className="text-xl md:text-[22px] mb-6">
            We uncover hard-to-reach email addresses with advanced tools that
            help you connect with anyone.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center md:justify-between w-full md:space-x-8">
          <div className="w-full md:w-1/2 grid grid-cols-1 md:grid-cols-1 gap-5 text-[22px] font-semibold mb-6">
            <ul className="space-y-5 text-xl md:text-[22px]">
              <li className="flex items-center">
                {/* <FaCheck className="text-[#4f7fff] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                High Accuracy Rate
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#4f7fff] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Unmatched Reach
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#4f7fff] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Flexible Search Methods
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#4f7fff] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Smart filtering options
              </li>
            </ul>
          </div>

          <div className="w-full flex justify-center mb-8 md:mb-0">
            <img
              src={MainImg3}
              alt="Features Illustration"
              className="w-full max-w-lg"
            />
          </div>

          <div className="w-full md:w-1/2 grid grid-cols-1 md:grid-cols-1 gap-5 text-[22px] font-semibold">
            <ul className="space-y-5 text-xl md:text-[22px]">
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Real Time Verification
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Bulk Search Capability
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                Affordable Pricing Plans
              </li>
              <li className="flex items-center">
                {/* <FaCheck className="text-[#3E69B9] mr-3 mt-1" /> */}
                <img
                  src={check}
                  alt="Checkmark"
                  className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
                />
                GDPR Compliance
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <img src={UnderImg} alt="Bottom decoration" className="w-full h-14" />
      </div>
    </>
  );
}
